import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  formatDateTime,
} from '../../../../utils';

/** components */
import Flex, { Grid } from '../../../../components/Flex';

import {
  Container,
} from './styles';

interface ICard {
  supervisors: any;
}

const Card: React.FC<ICard> = ({ supervisors }) => {
  const history = useHistory();

  return (
    <Grid item xs={12}>
      <Container onClick={() => history.push(`/ceperj/supervisao/detail/${supervisors.id}`)}>
        <Grid container spacing={1}>
          <Flex title="Ação" xs={6} sm={6} md={3}>
            <b> {supervisors?.action} </b>
          </Flex>
          <Flex title="Tipo" xs={6} sm={6} md={3}>
            <b> {supervisors?.type} </b>
          </Flex>
          <Flex title="Cidade da Ação" xs={6} sm={6} md={3}>
            <b> {supervisors?.city} </b>
          </Flex>
          <Flex title="Data" xs={6} sm={6} md={3}>
            <b> {formatDateTime(supervisors.created_at)} </b>
          </Flex>
        </Grid>
      </Container>
    </Grid>
  );
};

export default Card;
